<template>
  <div class="task-card" draggable="true" @dblclick="changeEditTaskView(true, task)" @dragstart="dragTask" @dragend="dragendTask">
    <!-- <div class="unread" v-if="unreadCnt > 0">
    </div> -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <p class="task-status">
        <span class="mdi mdi-clock-outline"></span> 
        <span class="-right-8px">{{getMin2Hour(task.time_min)}}</span> <br>
        <span class="mdi mdi-file-document" v-if="task.user_task_file.length > 0"></span>
        <span class="-right-8px" v-if="task.user_task_file.length > 0">添付</span>
      </p>
      <b-dropdown
        position="is-bottom-left"
        :scrollable="true"
        max-height="220"
        aria-role="list">
        <button class="button is-small" style="border: none;" type="button" slot="trigger">
          <b-icon icon="dots-vertical"></b-icon>
        </button>
        <b-dropdown-item @click="createEvent(task)">
          <p style="cursor: pointer;">
            <span class="mdi mdi-calendar-plus"></span>予定に反映
          </p>
        </b-dropdown-item>
        <b-dropdown-item @click="changeEditTaskView(true, task)">
          <p style="cursor: pointer;">
            <span class="mdi mdi-folder-edit"></span>タスクを編集する
          </p>
        </b-dropdown-item>
        <b-dropdown-item @click="changeSendTaskView(true, task)">
          <p style="cursor: pointer;">
            <span class="mdi mdi-send"></span>タスクを送付する
          </p>
        </b-dropdown-item>
        <b-dropdown-item @click="changeDeleteTaskView(true, task)">
          <p style="cursor: pointer;">
            <span class="mdi mdi-delete"></span>タスクを削除する
          </p>
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <p class="task-title"><span class="mdi mdi-text -right-4px"></span>{{task.title}}</p>
    <p class="task-desc" v-if="task.description!=''"><span class="mdi mdi-text-subject -right-4px"></span>{{task.description}}</p>
  </div>
</template>

<script>
import Tooltip from '@/components/atoms/tooltips/Tooltip'
export default {
  components: {
    Tooltip
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    unreadCnt () {
      let cnt = 0
      this.task.send_user_task_log.forEach((v) => {
        if (!v.is_read) cnt++
      })
      return cnt
    }
  },
  data () {
    return {
      createTask: {
        title: null,
        description: null,
        time_min: 60,
        file: []
      }
    }
  },
  methods: {
    getMin2Hour (min) {
      // 1時間未満の場合
      if (min < 60) return min
      else return Math.floor(min / 60) + ':' + ('00' + (min % 60)).slice(-2)
    },
    changeEditTaskView (flg, task) {
      // 既読にする
      if (this.unreadCnt > 0) {
        this.$emit('updateUserTaskLog', this.task.send_user_task_log)
      }
      this.$emit('changeEditTaskView', {
        'task': task,
        'flg' : flg
      })
    },
    changeSendTaskView (flg, task) {
      this.$emit('changeSendTaskView', {
        'task': task,
        'flg' : flg
      })
    },
    changeDeleteTaskView (flg, task) {
      this.$emit('changeDeleteTaskView', {
        'task': task,
        'flg' : flg
      })
    },
    createEvent (task) {
      this.$emit('createEvent', task)
    },
    dragTask () {
      this.$emit('dragTask', this.task)
    },
    dragendTask () {
      this.$emit('dragendTask', this.task)
    }
  }
}
</script>

<style lang="scss" scoped>
.task-card {
  display: inline-block;
  width: 140px;
  border-radius: 8px;
  left: -8px;
  border: solid thin #ccc;
  text-align: left;
  background: #FEFEFE;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  position: relative;
  cursor: pointer;
  .unread {
    position: absolute;
    top:   -8px;
    right: -8px;
    width:  24px;
    height: 24px;
    background: #C82E42;
    font-size: 14px;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .task-status {
    color: #666;
    font-size: 14px;
    font-weight: 600;
    margin-top: -4px;
  }
  .task-title {
    width: 100%;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 4px;
  }
  .task-desc {
    width: 100%;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    white-space: normal;
    -webkit-box-orient: vertical;
    max-height: 72px;
    word-break: break-all;
    margin-bottom: 8px;
  }
}
.line {
  width: 100%;
  height: 0.5px;
  border-bottom: dotted 4px #ccc;
  margin: 2px;
}
/deep/ .tooltip {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/organisms/TrelloCard.vue